export const DEFAULT_CURRENCY_ID = "4263309b-97c8-49ff-94a3-cd2f39bb2c90";

export interface IMenuUpgrade {
  menuUpgradeTitle: string;
  menuUpgradeQuantity: number;
  menuUpgradePrice: number;
}

export interface IOrderFoodItem {
  foodId: string;
  foodQuantity: number;
  foodNote: string;
  menuUpgrade: IMenuUpgrade[];
}

export interface IOrder {
  userId: string;
  totalAmount: number;
  foodList: IOrderFoodItem[];
  restourantId: string;
  currencyId: string;
}

export interface IPreOrderBody {
  userId: string;
  totalAmount: number;
  foodList: IOrderFoodItem[];
  restourantId: string;
  currencyId: string;
  promoCode?: string;
}

export interface IPreOrderResponse {
  id: string;
  preOrderTotalPrice: number;
  originalTotalPrice: number;
  discountAmount: number;
  /** Taken off by per-dish campaigns, before any promo code. */
  itemDiscountTotal?: number | null;
  promoCodeId: string | null;
}

export interface IOrderBody {
  preOrderId: string;
  orderNote: string;
  customerAddressId: string;
  paymentMethodId: string;
}

export interface IPaymentMethod {
  id: string;
  paymentMethodNameTr: string;
  paymentMethodNameEn: string;
  isActive: boolean;
}
